import React from 'react';
import NavLanguageSwitcher from "./NavLanguageSwitcher";

function Nav({children, ...props}) {

  return (
    <nav id={'nav'} className={'sticky flex top-0 w-full py-2 z-20 uppercase text-sm xs:text-base sm:text-lg lg:text-xl bg-black/90'}>
      <ul className={'nav-elements flex justify-center w-full '}>
        {children}
      </ul>
      <NavLanguageSwitcher/>
    </nav>
  );
}


export default Nav;
